import * as React from 'react';
import { useSelector } from 'react-redux';

import { getRateType } from '../../utils/getRateType';
import { ResponseTimeMobile } from './components/ResponseTimeMobile';
import { ResponseRateMobile } from './components/ResponseRateMobile';
import { getResponseTimeText } from '../../utils/getResponseTimeText';
import { selectChatsStatistics } from '../../selectors/selectChatsStatistics';

export const ChatStatisticsMobileContainer: React.FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const chatsStatistics = useSelector(selectChatsStatistics);
  const responseRate = chatsStatistics?.responseRate || 0;
  const averageResponseTime = chatsStatistics?.averageResponseTime || 0;

  const rateType = getRateType(responseRate);
  const rateValue = Math.round(responseRate * 100);

  if (!responseRate && averageResponseTime <= 0) {
    return null;
  }

  return (
    <>
      {!!responseRate && <ResponseRateMobile rateType={rateType} rateValue={rateValue} />}
      {averageResponseTime > 0 && (
        <ResponseTimeMobile responseTimeText={getResponseTimeText(averageResponseTime) || ''} />
      )}
    </>
  );
};
